// useAllowedCountries.ts
import { useEffect, useState } from 'react';

export const useAllowedCountries = () => {
  const [countryOptions, setCountryOptions] = useState<string[]>([]);

  useEffect(() => {
    fetch(
      `https://${process.env.REACT_APP_API_URL}/api/localisation/allowed-countries`,
    )
      .then((response: any) => response.json())
      .then((data) => {
        setCountryOptions(data);
      })
      .catch(() => {
        setCountryOptions([]);
      });
  }, []);

  return countryOptions;
};
